/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PitchBasic } from './pitch-basic';
import { User } from './user';

export interface DeckPitchesSubscription {
  readonly id: string;
  readonly user: User;
  readonly pitch: PitchBasic;
  readonly email: string;
  readonly subscribed: boolean;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
}
